const content = `<p>Creator is a GRASP principle that is the idea <a href="/information-expert">Information expert</a> generalized to object construction.</p>

<p>Information expert says that to choose which code should take on a certain responsibility, a good candidate is the class that already holds the data needed to accomplish it.</p>

<p>Creator generalises this idea to the particular responsibility of object creation. Which class should be in charge of creating objects of type <code>A</code>?</p>

<p>Creator says that it should be a class that already has a link with <code>A</code>. This includes:</p>

<ul><li>classes that contain objects of type <code>A</code></li><li>classes that aggregates objects of type <code>A</code></li><li>classes that otherwise interact with objects of type <code>A</code></li><li>classes that have the data needed to build an object of type <code>A</code></li></ul>

<p>Creator helps reduce coupling and increase cohesion by avoiding new links between classes just for the purpose of creating objects.</p>

<div class="notes">
<p>Key points:</p>

<ul><li>Creator suggests to choose classes that already have a link with the type of an object to create that object</li><li>Creator is like Information expert, generalised to object creation</li></ul>
</div>`

export default content
